import { createAction } from '@reduxjs/toolkit';
import { CompanyDisplayConfig } from 'type/company';

export const setPersonConfig = createAction<CompanyDisplayConfig>('switch/setPersonConfig');
